<script lang="ts">
    import {onMount} from "svelte";
    import PortalView from "../common/Portal/PortalView.svelte";
    import {SpaceTable} from "../../lib/Table/SpaceTable";
    import FontAwesomeView from "../common/Image/FontAwesomeView.svelte";

    export let space;

    $: hasManageAuthority = (() => {
        return SpaceTable.hasManage(space);
    })();

    onMount(() => {
    });


</script>

{#if hasManageAuthority}
    <PortalView portalTargetSelector="#header-right-portal-target">
        <a href={`/#/space/${space.unique_id}/setting`}>
            <FontAwesomeView icon="wrench"/>
            管理画面
        </a>
    </PortalView>
{/if}

